module.exports = __webpack_public_path__ + "static/media/striped_bar_SMAP.b791e685.svg";